// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29VbP","newExpiryDate":"styles_newExpiryDate__Dl9da","footer":"styles_footer__1wdWw"};